<template lang="html">
  <section>
    <div v-if="this.$store.state.itensSla.controleExibicaoImpressao">
      <b-table striped hover :items="glosasPorItem"> </b-table>
    </div>
  </section>
</template>

<script>
export default {
  props: ['filtro'],
  data () {
    return {
      glosasPorItem: [],
      env: process.env
    }
  },
  mounted () {
    this.getGlosasFiltroAnoIdContrato()
  },
  watch: {
    filtro: function () {
      this.getGlosasFiltroAnoIdContrato()
    }
  },
  methods: {
    getGlosasFiltroAnoIdContrato () {
      let vm = this
      console.warn('filtro', this.filtro)
      let formData = new FormData()
      formData.append('ano', this.filtro.ano)
      formData.append('contrato_id', this.filtro.contrato.contrato_id)
      if (this.filtro.contrato.contrato_id * 1 !== undefined) {
        this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/getGlosaImpressao`, formData, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
          }
        })
        .then(function (response) {
          vm.glosasPorItem = response.data.map(item => {
            return {
              mes: item.mes_nome,
              quantidade: item.quantidade,
              valor: item.valor
            }
          })
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GlosaImpressao.vue?9a024c44